import Icon from '../../icon/Icon';
import type { IconId } from '../../icon/icons';
import './ProductCardOverlay.less';

export type ProductCardOverlayProps = {
    isVisible?: boolean;
    text?: string;
    iconId?: IconId;
};

const ProductCardOverlay = ({
    isVisible,
    text,
    iconId
}: ProductCardOverlayProps) => (
    <div className={`bri-ProductCardOverlay ${isVisible ? 'bri-visible' : ''}`}>
        {iconId && <Icon iconId={iconId} size="small" />}
        {text && <div className={`bri-BodySmallFont`}>{text}</div>}
    </div>
);

export default ProductCardOverlay;
